import React from 'react';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers-v5/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers-v5/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers-v5/DatePicker';
import { ThemeProvider } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import { InputAdornment } from '@mui/material';

const PICKER_MIN_DATE = '2000';
const PICKER_MAX_DATE = '2050';

export default function YearPicker(props) {
  const {
    value: initialDate = null,
    renderInput = ({ inputRef, inputProps, InputProps }) => (
      <TextField
        {...inputProps}
        ref={inputRef}
        type="text"
        value={inputProps.value}
        size="small"
        className="d-block bg-white form-control w-100 h-100"
        InputProps={{
          endAdornment: <InputAdornment position='end'>{InputProps?.endAdornment}</InputAdornment>,
          placeholder: ''
        }}
        sx={{
          ...inputProps.sx,
          '& .MuiInputBase-root': {
            width: '100%'
          }
        }}
      />
    )
  } = props;

  const [selectedDate, setSelectedDate] = React.useState(null);

  React.useEffect(() => {
    const date = dayjs(String(initialDate));
    setSelectedDate(!isNaN(date.$y) ? date : null);
  }, [initialDate]);

  return (
    <ThemeProvider theme={backYouTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={ENV.lang.split('_').shift()}>
        <DatePicker
          {...props}
          views={['year']}
          value={selectedDate}
          onChange={(newValue) => {
            const year = newValue ? newValue.$y : null;
            setSelectedDate(newValue);
            props.parentFunction(year, props.slug);
          }}
          renderInput={renderInput}
          minDate={props.minDate ?? dayjs(PICKER_MIN_DATE)}
          maxDate={props.maxDate ?? dayjs(PICKER_MAX_DATE)} 
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}